import { defineStore } from "pinia";
import { Configuration } from "../models/configuration.model";

export const useConfigStore = defineStore('configuration', {
    state: () => (<Configuration>{
        loaded: false,
        clientId: 'lab-dasboard',
        clientSecret: '2b7aa83f4e87c97ce4261643e50e641a940cd757',
        environment: 'dev',
        apiEndpoint: null,
        jwtEndpoint: null,
        VERSION: null,
    }),

    actions: {
        load(): void {
            const settings: string = document.getElementById('settings')?.textContent || '';
            try {
                this.$state = { ...this.$state, ...JSON.parse(settings) };
                this.loaded = true;
            } catch(e) {
                console.error('Could not load configuration. Something went wrong');
            }
        }
    }
});